import axios from "axios";
export default {
    state:{
        establecimiento:[],
    },
    mutations:{
        setAllEstablecimientos(state,items){
            state.establecimiento=items
        }
    },
    actions:{
        async setAllEstablecimientos({commit,rootState,getters}){

            try {
                const {data }= await axios.get(`${rootState.urlapi}/establecimientos`,getters.getTokenUser)
                commit("setAllEstablecimientos",data)
            } catch (error) {
                console.error(error)
            }
           
        }
    },
    getters:{
        getAllEstablecimientos(state){
            return state.establecimiento
        },
        getEstablecimientosActivas(state){
            return state.establecimiento.filter(item=>item.estado=='Activo')
        }
    }
}